// extracted by mini-css-extract-plugin
module.exports = {"container":"AmountCanvasesCollage_container__2p3sO"};